import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createBrowserRouter, createRoutesFromChildren, matchRoutes,
  Routes, useLocation, useNavigationType
} from 'react-router';

import { beforeSend } from './SentryHelpers';


Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  ignoreErrors: [/@webkit-masked-url/],
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: false,
    }),
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),

  ],
  // Only increase SessionSampleRate if you are sure about volumes, it can cost ton of money
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.2,
  beforeSend,
  tracesSampleRate: 0,
});

export const SentryRoutes = Sentry.wrapReactRouterRouting(Routes);

// is fine is as per documentation suggestion https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/
export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
